module.exports = __webpack_public_path__ + "static/media/access-first@3x.2ff81304.jpg";